<template>
  <div class="business-intelligence-potential-bidders-list" :class="size">
    <BasePotentialBidder
      v-for="bid in shownBids"
      :key="bid.id"
      :potentialBidder="bid"
      :source="source"
      :hasWinner="hasWinner"
      size="compact"
      @add-competitor="onAddCompetitorClicked"
      @edit-competitor="onEditCompetitorClicked"
      @add-winner="onAddWinnerClicked"
      @action-succeeded="onActionSucceeded"
    />
    <v-popover
      placement="top"
      trigger="hover"
      popoverClass="business-intelligence__potential-bidders-list-tooltip"
      v-if="hiddenBids.length > 0"
    >
      <span>+{{ hiddenBids.length }}</span>
      <template v-slot:popover>
        <div>
          <div class="__bid-item" v-for="(bid, index) in hiddenBids" :key="index">
            <span>{{ bid.organization_name }}</span>
          </div>
        </div>
      </template>
    </v-popover>
  </div>
</template>
<script>
import BasePotentialBidder from '@/components/base/BasePotentialBidder.vue';

export default {
  name: 'BIPotentialBiddersList',
  components: { BasePotentialBidder },
  props: {
    size: {
      type: String,
      default: () => 'compact', // compact, full
    },
    tenderId: {
      type: String,
    },
    potentialBidders: {
      type: Array,
      required: true,
      default: () => [],
    },
    limit: {
      type: Number,
      required: false,
      default: 3,
    },
    hasWinner: {
      type: Boolean,
      required: false,
      default: false,
    },
    source: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    sortedBids() {
      const rank = (b) => (b.is_competitor ? 0 : b.is_tenant ? 1 : b.is_existing_competitor ? 2 : 3);
      return [...this.potentialBidders].sort((a, b) => rank(a) - rank(b));
    },
    shownBids() {
      return this.sortedBids.slice(0, this.limit);
    },
    hiddenBids() {
      return this.sortedBids.slice(this.limit);
    },
  },
  methods: {
    getVariant(bid) {
      if (bid.is_competitor) {
        return 'active';
      } else if (bid.is_tenant) {
        return 'emphasis';
      }
      return 'default';
    },
    onAddCompetitorClicked(supplier_name) {
      this.$emit('add-competitor', supplier_name);
    },
    onEditCompetitorClicked(competitor, name) {
      this.$emit('edit-competitor', competitor, name);
    },
    onAddWinnerClicked(bid) {
      this.$emit('add-winner', this.tenderId, bid.organization_name, bid.amount);
    },
    onActionSucceeded() {
      this.$emit('action-succeeded');
    },
  },
};
</script>

<style lang="scss">
.business-intelligence-potential-bidders-list {
  display: flex;
  width: 100%;
  gap: 8px;

  &.compact {
    flex-direction: row;
  }

  &.full {
    flex-direction: column;
  }
}

.business-intelligence__potential-bidders-list-tooltip {
  padding: 8px;
  font-size: $font-size-xsmall;
  background-color: $color-normal !important;
  color: $color-white !important;
  box-shadow: $shadow-tooltip;

  .popover-arrow {
    background-color: $color-normal !important;
  }

  .__bid-item {
    display: flex;
    gap: 8px;
    justify-content: space-between;

    &:not(:last-child) {
      margin-bottom: 4px;
    }
  }
}
</style>
